import { useQuery } from "@tanstack/react-query";
import { fetchReportsBetweenDates, fetchPlannedReports } from "../../../api/reportsApi";
import { GetReportsBetweenDatesResult } from "../../../types/Rows";
import { PlannedReport } from "../../../api/reportsApi";
import { getMonthRange } from "../utils/calendarHelpers";

export const useCalendarData = (currentMonth: Date) => {
  const { startDate, endDate } = getMonthRange(currentMonth);

  const { data: reports, isLoading: reportsLoading, error: reportsError } = useQuery<GetReportsBetweenDatesResult[]>(
    ["calendar-reports", startDate.toISOString(), endDate.toISOString()],
    () => fetchReportsBetweenDates(startDate, endDate),
    {
      refetchOnWindowFocus: false,
      // przy zmianie miesiąca zostają poprzednie wydarzenia zamiast ekranu ładowania całej strony
      keepPreviousData: true,
    }
  );

  const { data: plannedReports, isLoading: plannedLoading, error: plannedError } = useQuery<PlannedReport[]>(
    ["calendar-planned", startDate.toISOString(), endDate.toISOString()],
    () => fetchPlannedReports(startDate, endDate),
    {
      refetchOnWindowFocus: false,
      // przy zmianie miesiąca zostają poprzednie wydarzenia zamiast ekranu ładowania całej strony
      keepPreviousData: true,
    }
  );

  return {
    reports: reports || [],
    plannedReports: plannedReports || [],
    isLoading: reportsLoading || plannedLoading,
    error: reportsError || plannedError,
    startDate,
    endDate,
  };
};
